<template src="./index.html"></template>

<script>

export default {
  data: function () {
    return {
      tableData: [
        {
          xuh: 1,
          dklhm: 36491598,
          dklrq: "2019-09-29",
          rzrq: "2019-9-24",
          shangpmc: "扫描仪",
          qbgjhwje: "3982.3",
          qbjxse: "517.7",
          rjgjhwje: "0",
          rjjxse: "0",
          sm: "此项为单纯的硬件扫描仪买卖，与速元发票数字化管理平台软件毫无关系，故没有进行分摊。",
        },
        {
          xuh: 2,
          dklhm: 52216998,
          dklrq: "2019-09-29",
          rzrq: "2019-9-24",
          shangpmc: "水电费",
          qbgjhwje: "1610.59",
          qbjxse: "204.86",
          rjgjhwje: "1029.33",
          rjjxse: "130.93",
          sm: "此项属于难以分清的项目，故进项税额按软件产品占总销售额的63.91%比例进行分摊",
        },
        {
          xuh: "合计",
          qbgjhwje: "5592.89",
          qbjxse: "722.56",
          rjgjhwje: "1029.33",
          rjjxse: "130.93",
        }
      ],
      data: {
        suosq: "2019年09期",
        companyName: "上海速元信息技术有限公司",
        illustrate: "上海市浦东新区税务局：我司是上海速元信息技术有限公司，2019年9月进项税额合计722.56元，现具体解释如下表：",
        writeTime: "2019年10月18日",
      }
    };
  },
  created() {
  },
  mounted() {
  },
  components: {},
  methods: {
  },
};
</script>

<style scoped lang="less">
@import url("./index.less");
</style>
